<script>

    export let label = null
    export let value = null
    export let placeholder = null
    export let pattern = null

    export let required = true
    export let step = '0.01'
    export let max = null
    export let min = null

    export let readonly = false

    const uid = `input-${Math.random().toString(36).slice(2, 9)}`

</script>

<div class="field">
    {#if label}
        <label for={uid} class="label">{ label }</label>
    {/if}
    <div class="control">
        <input id={uid} bind:value={ value } class="input" type="number" { pattern } { step } { max } { min } { placeholder } { required } { readonly } >
    </div>
</div>
